<template>
  <div class="cancelChoun">
    <base-title text="今日の運勢を解約する" type="back" @click.prevent.native="back" />
    <div class="cancelChoun__main">
      <img class="topImg" src="/static/img/choundiary/maro.png" />
      <p class="head">本当に解約しますか？</p>
      <p class="description">
        {{ cancelDate | convertKanjiYMD }}以降、{{ menuArray.menu_title }}が利用できなくなります。
      </p>
      <form
        class="do"
        ref="form"
        :action="action"
        :method="method"
        :token="token"
        @submit.prevent
      >
        <input type="hidden" name="_token" :value="token">
        <input type="hidden" name="menu_id" :value="menuArray.menu_id">
        <input type="hidden" name="diary_token" :value="diaryToken">
        <div class="button">
          <BaseButtonChoun
            class="back"
            label="戻る"
            @clicked="back"
          />
          <BaseButtonChoun
            class="do"
            label="解約する"
            design="cancel"
            @clicked="submit"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SubmitButton from '../partials/SubmitButton'
import BaseButtonChoun from './partials/BaseButtonChoun'
import BaseTitle from './partials/BaseTitle'

export default {
  name: "CancelChoun",
  components: {
    BaseTitle,
    SubmitButton,
    BaseButtonChoun,
  },
  props: {
    action: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'POST'
    },
    token: {
      type: String,
      default: ''
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    chounUser: {
      type: Object,
      default() {
        return {}
      }
    },
    menuArray: {
      type: Object,
      default() {
        return {}
      }
    },
    diaryToken: {
      type: String,
      default: ''
    },
  },
  computed:{
    cancelDate(){
      return moment(this.chounUser.current_period_to).add(1, 'days').format()
    }
  },
  methods: {
    back(){
      history.back()
    },
    submit() {
      this.$refs.form.submit()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.cancelChoun {
  color: $diary_text1;
  &__main {
    padding: 16px 24px;
  }
  .topImg {
    width: 105px;
    margin: 0 auto;
    display: block;
  }
  .head {
    font-weight: bold;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    margin-top: 21px;
  }
  .description {
    margin: 16px 0 32px;
    font-size: 13px;
    line-height: 21px;
  }
  .button {
    display: flex;
    .back {
      margin-right: 8px;
      width: 50%;
    }
    .do {
      width: 50%;
    }
  }
}
p{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ChounDiary/CancelChoun.vue